import api from './api';

export interface Medicine {
  id: number;
  name: string;
  code: string;
  active_ingredient: string;
  dosage_form: string;
  strength: string;
  manufacturer: string;
  registration_number: string;
  unit: string;
  min_stock_level: number;
  max_stock_level: number;
  category: string;
  description: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface Category {
  id: number;
  name: string;
  description: string;
  color: string;
  icon: string;
}

export interface Unit {
  id: number;
  name: string;
  description: string;
}

export interface DosageForm {
  id: number;
  name: string;
  description: string;
}

export interface AuxiliaryData {
  categories: Category[];
  units: Unit[];
  dosageForms: DosageForm[];
}

export interface CreateMedicineRequest {
  name: string;
  code: string;
  active_ingredient: string;
  dosage_form: string;
  strength: string;
  manufacturer: string;
  registration_number: string;
  unit: string;
  min_stock_level: number;
  max_stock_level: number;
  category: string;
  description: string;
}

export interface UpdateMedicineRequest extends Partial<CreateMedicineRequest> {
  id: number;
}

class MedicineService {
  // Lấy danh sách thuốc
  async getMedicines(): Promise<Medicine[]> {
    const response = await api.get('/api/medicines');
    return response.data.data;
  }

  // Tìm kiếm thuốc
  async searchMedicines(query: string): Promise<Medicine[]> {
    const response = await api.get(`/api/medicines/search/${query}`);
    return response.data.data;
  }

  // Lấy thuốc theo ID
  async getMedicineById(id: number): Promise<Medicine> {
    const response = await api.get(`/api/medicines/${id}`);
    return response.data.data;
  }

  // Tạo thuốc mới
  async createMedicine(data: CreateMedicineRequest): Promise<{ medicineId: number }> {
    const response = await api.post('/api/medicines', data);
    return response.data;
  }

  // Cập nhật thuốc
  async updateMedicine(data: UpdateMedicineRequest): Promise<void> {
    await api.put(`/api/medicines/${data.id}`, data);
  }

  // Xóa thuốc
  async deleteMedicine(id: number): Promise<void> {
    await api.delete(`/api/medicines/${id}`);
  }

  // Lấy dữ liệu phụ trợ từ master data
  async getAuxiliaryData(): Promise<AuxiliaryData> {
    const response = await api.get('/api/medicines/auxiliary-data');
    return response.data.data;
  }
}

export const medicineService = new MedicineService(); 